import {
  useVariableValue,
  useIsDevCycleInitialized,
} from '@devcycle/react-client-sdk';
import { getConfig } from 'src/utilities/config';

const useRealDevCycle = (
  key: string,
  defaultValue: boolean
): { isInitialized: boolean; value: boolean } => {
  const isInitialized = useIsDevCycleInitialized();
  const value = useVariableValue(key, defaultValue);

  return { isInitialized, value };
};

const useNoOpDevCycle = (
  _: string,
  defaultValue: boolean
): { isInitialized: boolean; value: boolean } => {
  return {
    isInitialized: true,
    value: defaultValue,
  };
};

export const getIsDevCycleAvailable = (): boolean => {
  const { devcycleSdkKey } = getConfig();

  return !!devcycleSdkKey;
};

export const useDevCycleAdapter = getIsDevCycleAvailable()
  ? useRealDevCycle
  : useNoOpDevCycle;
